/**************************************************************************************************************************************************
*   MODULE NAME     :  User Actions
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  02-03-2021
*   DESCRIPTION     :  User API actions
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
/**************************************************************************************************************************************************/

import * as types from "./actionTypes";
import UserApi from "../api/UserApi";

/******* ACTION OBJECTS *******/
export const loadUsersDataSuccess = usersData => {
  return {
    type: types.LOAD_USERS_DATA_SUCCESS,
    usersData
  };
};
export const loadActiveInactiveUsersDataSuccess= activeInactiveUsersData => {
  return {
    type: types.LOAD_ACTIVE_INACTIVE_USERS_DATA_SUCCESS,
    activeInactiveUsersData
  };
};

export const loadLoggedUserSuccess = (loggedUserDetail) => {
  return {
    type: types.LOAD_LOGGED_USER_SUCCESS,
    loggedUserDetail,
  };
};

export const loadAuthProviderSuccess = (authProvider) => {
  return {
    type: types.LOAD_AUTH_PROVIDER_SUCCESS,
    authProvider
  }
}



/*****  ACTION DISPATCHERS  ******/
export const loadUsersData = () => {
  return async dispatch => {
    try {
      const usersData = await UserApi.getAllUsers();
      dispatch(loadUsersDataSuccess(usersData));
      return usersData;
    } catch (error) {
      throw error;
    }
  };
};
export const loadActiveInactiveUsersData = () => {
  return async dispatch => {
    try {
      const usersData = await UserApi.getActiveInactiveUsers();
      dispatch(loadActiveInactiveUsersDataSuccess(usersData));
      return usersData;
    } catch (error) {
      throw error;
    }
  };
};
export const createUser = payload => {
  return async () => {
    try {
      return await UserApi.createUser(payload);
    } catch (error) {
      throw error;
    }
  };
};


export const loadLoggedUser = (userData) => {
  return async (dispatch) => {
    try {
      dispatch(loadLoggedUserSuccess(userData));
      return userData;
    } catch (error) {
      return error;
    }
  };
};

export const loadAuthProvider = (authProvider) => {
  return async (dispatch) => {
    try {
      dispatch(loadAuthProviderSuccess(authProvider))
      return authProvider;
    } catch (error) {
      return error;
    }
  }
}

